<template>
    <div id="member-calculator" ref="calculator">
        <section>
            <div class="tab stopwatch-icon">Limited Time Offers</div>
            <div class="tab-divider"></div>
            <div class="row">
                <div class="col-lg-4 col-md-6">
                    <div class="pr-3">
                        <p>
                            Double cash back bonus on AAA purchases, travel and insurances for the first 6 months up to $6,000.
                        </p>
                        <p>
                            <em>4% cash back on AAA purchases, travel and insurance for the first 6 months (up to $6,000).
                                After that, earn unlimited cash back in the standard 2% cash back category.</em>
                        </p>
                        <div class="input-group my-3">
                            <div class="input-group-prepend">
                                <span class="input-group-text" id="purchases-label">$</span>
                            </div>
                            <input type="number"
                                   @blur="validateValue('aaaPurchases')"
                                   v-model.number="aaaPurchases"
                                   class="form-control prepend-left"
                                   aria-label="Purchases"
                                   aria-describedby="purchases-label"
                            >
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section>
            <div class="tab">3% Cash Back</div>
            <div class="tab-divider"></div>
            <div class="row">
                <div class="col-md-4 d-flex">
                    <div class="pr-3 d-flex flex-column justify-content-between w-100">
                        <div class="calc-icon calc-grocery">
                            <p>
                                Grocery stores and grocery delivery
                            </p>
                            <p>
                                <em>Earn 3% cash back</em>
                            </p>
                        </div>
                        <div class="input-group my-3">
                            <div class="input-group-prepend">
                                <span class="input-group-text" id="grocery-label">$</span>
                            </div>
                            <input
                                type="number"
                                min="0"
                                @blur="validateValue('grocery')"
                                v-model.number="grocery"
                                class="form-control prepend-left"
                                aria-label="Groceries"
                                aria-describedby="grocery-label"
                            >
                        </div>
                    </div>
                </div>
                <div class="col-md-4 d-flex">
                    <div class="pl-3 d-flex flex-column justify-content-between w-100">
                        <div class="calc-icon calc-dining">
                            <p>
                                Dining, takeout and food delivery
                            </p>
                            <p>
                                <em>Earn 3% cash back</em>
                            </p>
                        </div>
                        <div class="input-group my-3">
                            <div class="input-group-prepend">
                                <span class="input-group-text" id="dining-label">$</span>
                            </div>
                            <input
                                type="number"
                                min="0"
                                @blur="validateValue('dining')"
                                v-model.number="dining"
                                class="form-control prepend-left"
                                aria-label="Dining"
                                aria-describedby="dining-label"
                            >
                        </div>
                    </div>
                </div>
                <div class="col-md-4 d-flex">
                    <div class="pl-3 d-flex flex-column justify-content-between w-100">
                        <div class="calc-icon calc-gas">
                            <p>
                                Gas stations
                            </p>
                            <p>
                                <em>Earn 3% cash back</em>
                            </p>
                        </div>
                        <div class="input-group my-3">
                            <div class="input-group-prepend">
                                <span class="input-group-text" id="gas-label">$</span>
                            </div>
                            <input
                                type="number"
                                min="0"
                                @blur="validateValue('gas')"
                                v-model.number="gas"
                                class="form-control prepend-left"
                                aria-label="Gas"
                                aria-describedby="gas-label"
                            >
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section id="Calc2">
            <div class="row">
                <div class="col-md-4">
                    <div class="d-none d-md-block">
                        <div class="tab">2% Cash Back</div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="tab ml-3">1% Cash Back</div>
                </div>
            </div>

            <div class="tab-divider"></div>
            <div class="row">
                <div class="col-md-4 d-flex">
                    <div class="pr-3 d-flex flex-column justify-content-between w-100">
                        <p class="mb-3">
                            AAA membership, travel and insurance purchases
                        </p>

                        <p>
                            <em>Earn 2% cash back</em>
                        </p>
                        <div class="input-group my-3">
                            <div class="input-group-prepend">
                                <span class="input-group-text" id="membership-label">$</span>
                            </div>
                            <input
                                type="number"
                                min="0"
                                @blur="validateValue('aaaMembership')"
                                v-model.number="aaaMembership"
                                class="form-control prepend-left"
                                aria-label="AAA membership"
                                aria-describedby="membership-label">
                        </div>
                    </div>
                </div>
                <div class="col-md-4 d-flex">
                    <div class="pl-3 d-flex flex-column justify-content-between w-100">
                        <p class="mb-3">
                            All other qualifying spend
                        </p>
                        <p>
                            <em>Earn 1% cash back</em>
                        </p>
                        <div class="input-group my-3">
                            <div class="input-group-prepend">
                                <span class="input-group-text" id="other-purchases-label">$</span>
                            </div>
                            <input
                                type="number"
                                min="0"
                                @blur="validateValue('otherPurchases')"
                                v-model.number="otherPurchases"
                                class="form-control prepend-left"
                                aria-label="Other purchases"
                                aria-describedby="other-purchases-label">
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section id="Calc4">
            <div class="tab-divider mt-5"></div>
            <h3 class="pt-2">Potential yearly cash back:</h3>
            <div class="row mb-5">
                <div class="col-md-8">
                    <div class="pr-5">
                        <table id="CalculatorTotals">
                            <tbody>
                            <tr>
                                <th>Yearly cash back:</th>
                                <th></th>
                                <th>6 month bonus<sup>†</sup>:</th>
                                <th></th>
                            </tr>
                            <tr>
                                <td>${{ yearlyCashBack }}</td>
                                <td>+</td>
                                <td>${{ sixMonthBonus }}</td>
                                <td>=</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="border-contain">
                        <div class="p-4">
                            First year potential cash back:
                            <div class="calc-total">${{ firstYearCashBack }}</div>
                        </div>
                        <div class="border-contain-btm d-print-none">
                            <ul>
                                <li class="icon-btn">
                                    <a @click="print" href="javascript:void(0)">
                                        <img src="/images/global/print-icon.svg" alt="Print Icon">
                                        <span>Print</span>
                                    </a>
                                </li>
                                <li class="icon-btn">
                                    <a @click="download" href="javascript:void(0)">
                                        <img src="/images/global/download-icon.svg" alt="Download Icon">
                                        <span>Download</span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="d-print-none">
            <p>
                <sup>†</sup>Earn 4% cash back on qualifying AAA purchases, travel and insurance for the first 6 months up to $6,000. After that, earn cash back in the standard 2% cash back category.
            </p>
            <p><strong>Note:</strong> this calculator is for illustrative purposes.</p>
        </section>
        <section class="d-print-block d-none mt-3">
            <p class="mb-1">
                <sup>†</sup>Earn 4% cash back on qualifying AAA purchases, travel and insurance for the first 6 months up to $6,000. After that, earn cash back in the standard 2% cash back category.
            </p>
            <p class="mb-1"><strong>Note:</strong> this calculator is for illustrative purposes.</p>
        </section>
        <footer class="pdf-only mt-3">
            <div class="footer1 py-0">
                This card is issued by U.S. Bank NA dba ACG Card Services, pursuant to a license from Visa USA Inc.
            </div>
            <div class="footer2 py-0 bg-transparent">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-md-6 l-footer pr-lg-5 d-print-none">
                            <img class="browser-icons" src="/images/global/browser-icons.png" alt="Chrome, Firefox, Safari">
                            This site supports the current versions of Chrome, Edge, Firefox and Safari. If you are using an unsupported browser, this site may not display properly.
                        </div>
                        <div class="col-12 text-body">
                            &copy;{{ year }} ACG Card Services. All Rights Reserved. Equal Credit Opportunity Lender.
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    </div>
</template>

<script>
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';

const today = new Date();

export default {
    data() {
        return {
            aaaPurchases: 0,
            introOffer: false,
            grocery: 0,
            dining: 0,
            gas: 0,
            aaaMembership: 0,
            otherPurchases: 0,
            year: today.getFullYear()
        }
    },
    methods: {
        validateValue(model) {
            if (!this[model]) {
                this[model] = 0.00;
            } else {
                const value = this[model].toString().replace(/\D/g,'');

                if (!value.length) {
                    this[model] = 0.00;
                } else {
                    this[model] = parseFloat(value);
                }
            }
        },
        print() {
            window.print();
        },
        async download() {
            const doc = new jsPDF({
                orientation: 'p',
                format: 'a4'
            });

            const canvas = await html2canvas(this.$refs.calculator, {
                onclone: (document) => {
                    document.documentElement.style.fontSize = '.95rem';

                    const hiddenEls = document.querySelectorAll('.d-print-none');

                    hiddenEls.forEach(el => el.style.display = 'none');

                    const blockEls = document.querySelectorAll('.d-print-block.d-none, .pdf-only');

                    blockEls.forEach(el => el.setAttribute('style', 'display:block !important'));
                },
                windowWidth: 980
            })
            const img = canvas.toDataURL('image/png', 9);

            doc.addImage(img, 10, 1, (doc.internal.pageSize.getWidth() - 20), (doc.internal.pageSize.getHeight() - 20));
            doc.save('calculator.pdf');
        }
    },
    computed: {
        sixMonthBonus() {
            if (this.aaaPurchases > 6000) {
                return Number((6000 * .04).toFixed(2));
            } else {
                return (this.aaaPurchases * .04).toFixed(2);
            }
        },
        yearlyCashBack() {
            const grocery = this.grocery.toString().length ? this.grocery : 0;
            const dining = this.dining.toString().length ? this.dining : 0;
            const gas= this.gas.toString().length ? this.gas : 0;
            const cde = ((grocery + dining + gas) * .03);
            const f = this.aaaMembership * .02;
            const g = this.otherPurchases * .01;
            let sixMonthRemainder = 0;

            if (this.aaaPurchases > 6000) {
                sixMonthRemainder = Number(((this.aaaPurchases - 6000) * .02).toFixed(2))
            }

            return (cde + f + g + sixMonthRemainder).toFixed(2);
        },
        ninetyDayBonus() {
            return this.introOffer ? 100 : 0;
        },
        firstYearCashBack() {
            return (
                parseFloat(this.sixMonthBonus.toString()) +
                parseFloat(this.yearlyCashBack.toString()) +
                parseFloat(this.ninetyDayBonus.toString())
            ).toFixed(2);
        }
    }
}
</script>
